import _ from 'lodash';
import React, { Component } from 'react';
import { colorCalculate } from '../utils';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = {
  padding: {
    padding: '0 24px'
  },
  value: {
    width: 'auto',
    padding: '0 6px',
    display: 'inline-block',
    textAlign: 'center',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.75)'
  },
  bottomBar: {
    zIndex: 1201,
    boxShadow: 'none',
    bottom: 0,
    height: 25,
    top: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    background: '#424242'
  },
  monospace: {
    fontFamily: 'Inconsolata'
  },
  anglePadding: {
    paddingLeft: 24
  }
};

class Footer extends Component {
  render() {
    const { classes } = this.props;

    return (
      <AppBar
        position='absolute'
        className={ classes.bottomBar }
      >
        <Grid container className={ classes.padding } justify='space-between'>
          <Grid item>
            <Typography className={ classes.monospace }>
              { this.props.latitude ? <span>{ this.props.latitude }, { this.props.longitude }</span> : null }
              <span className={ classes.anglePadding }>{ (this.props.metadata.angle ? this.props.metadata.angle : '') }</span>
              <span className={ classes.padding }>{ (this.props.metadata.elevation ? this.props.metadata.elevation : '') }</span>
              { this.props.enableSlider ? null :
                <span
                  // style={{
                  //   backgroundColor: _.get(this.props, 'metadata.value', false) ? colorCalculate(this.props.quadrantI.selectedColor, this.props.metadata)[1] : 'transparent'
                  // }}
                  className={ classes.value }
                  dangerouslySetInnerHTML={{
                    __html: _.get(this.props, 'metadata.value', false) ? this.props.metadata.value >= 800 ? 'RF' : `${this.props.metadata.value}${this.props.quadrantI.units}` : ''
                  }}
                />
              }
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={ classes.monospace }>
              <span className={ classes.padding }>Moore, Oklahoma - 2013/05/20 20:16:43</span>
              <span className={ classes.anglePadding }>
                <span className={ classes.padding }>&copy; { new Date().getFullYear() } Alex Neises </span>
                <a href='mailto:alex@nexview.io'>alex@nexview.io</a>
              </span>
            </Typography>
          </Grid>
        </Grid>
      </AppBar>
    );
  }
}

const mapStateToProps = state => {
  return {
    quadrantI: {
      product: state.mapReducer.quadrantI.product,
      units: state.mapReducer.quadrantI.units,
      selectedColor: state.mapReducer.quadrantI.selectedColor
    },
    site: state.mapReducer.site,
    latitude: state.mapReducer.lat,
    longitude: state.mapReducer.lon,
    metadata: state.mapReducer.properties,
    enableSlider: state.mapReducer.enableSlider
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Footer));